<ul class="nav nav-tabs" role="tablist" [style]="getTabAlignment()">
  <li
    class="nav-item"
    [class.active]="i === activeIndex"
    [class.disabled]="tab.disabled"
    [class]="tab.className"
    *ngFor="let tab of tabs; let i = index"
  >
    <a class="nav-link" (click)="setActiveTab(tab, i)">
      <i *ngIf="tab.icon" class="text-secondary fa fa-{{ tab.icon }}"></i>
      {{ tab.label
      }}<span class="tab-count" *ngIf="tab.count"
        >({{ tab.count | number }})</span
      ></a
    >
  </li>
</ul>

<div class="tab-content">
  <ng-container *ngTemplateOutlet="activeTabContent"></ng-container>
  <ng-content></ng-content>
</div>
